import { sessionStorageApi } from './storage';

const sessionPreviousLocation = sessionStorageApi('previousLocation');
const storageAfterLogin = sessionStorageApi('afterLogin');
const storageClaimedPromo = sessionStorageApi('claimedPromo');

export { sessionPreviousLocation, storageAfterLogin, storageClaimedPromo };
